module.exports = __webpack_public_path__ + "static/media/Atlantic_Road_Bergen_Norway_4.1e558eca.jpg";